import { getUserLocation } from '../components/StoreDrawer/utils';

export { getUserLocation };
